import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSettingsIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M15.0938 9.1875C16.1811 9.1875 17.0625 8.30606 17.0625 7.21875C17.0625 6.13144 16.1811 5.25 15.0938 5.25C14.0064 5.25 13.125 6.13144 13.125 7.21875C13.125 8.30606 14.0064 9.1875 15.0938 9.1875ZM15.0938 3.84375C16.6664 3.84375 17.9878 4.91934 18.3624 6.375H20.1562H21V8.0625H20.1562H18.3624C17.9878 9.51816 16.6664 10.5938 15.0938 10.5938C13.5211 10.5938 12.1997 9.51816 11.8251 8.0625H3.84375H3V6.375H3.84375H11.8251C12.1997 4.91934 13.5211 3.84375 15.0938 3.84375ZM20.1562 17.625H21V15.9375H20.1562H12.1749C11.8003 14.4819 10.4789 13.4062 8.90625 13.4062C7.33363 13.4062 6.01224 14.4819 5.63757 15.9375H3.84375H3V17.625H3.84375H5.63757C6.01224 19.0806 7.33363 20.1562 8.90625 20.1562C10.4789 20.1562 11.8003 19.0806 12.1749 17.625H20.1562ZM10.875 16.7827V16.7812V16.7798C10.8742 15.6932 9.99307 14.8125 8.90625 14.8125C7.81894 14.8125 6.9375 15.6939 6.9375 16.7812C6.9375 17.8686 7.81894 18.75 8.90625 18.75C9.99307 18.75 10.8742 17.8693 10.875 16.7827Z",
		fill: "currentColor"
	})
});
export default SvgSettingsIcon;
